<template>
  <div id="pageProperty">
    <a-row class="pageProperty-btn" type="flex" justify="start">
      <a-col>
        <a-tooltip placement="topLeft">
          <template slot="title">
            <span>{{ $t("generic.Refresh") }}</span>
          </template>
          <img style="margin-left: 10px;" @click="iniFreshTable('resh')" class="sbxs" src="../../../assets/img/ss-refresh.png"  width="22" height="22">
        </a-tooltip>
        <a-popconfirm
          title="Are you sure delete this task?"
          @confirm="deletePageProperty"
          okText="Yes"
          cancelText="No"
        >
          <a-tooltip placement="topLeft">
            <template slot="title">
              <span>{{ $t("generic.Delete") }}</span>
            </template>
            <img style="margin: 0 10px" class="sbxs" src="../../../assets/img/ss-delete.png"  width="22" height="22">
          </a-tooltip>
        </a-popconfirm>
        <a-tooltip placement="topLeft">
          <template slot="title">
            <span>{{ $t("generic.Up") }}</span>
          </template>
          <a-button
            size="small"
            type="primary"
            shape="circle"
            icon="arrow-up"
            style="background: #719844;border:none"
            @click="arrowUpEvent"
          ></a-button>
        </a-tooltip>
        <a-tooltip placement="topLeft">
          <template slot="title">
            <span>{{ $t("generic.Down") }}</span>
          </template>
          <a-button
            size="small"
            type="primary"
            shape="circle"
            icon="arrow-down"
            style="background: #ef4b12;border:none"
            @click="arrowDown"
          ></a-button>
        </a-tooltip>

        <!--<a-tooltip placement="topLeft">-->
          <!--<template slot="title">-->
            <!--<span>Top</span>-->
          <!--</template>-->
          <!--<a-button-->
                  <!--size="small"-->
                  <!--type="primary"-->
                  <!--shape="circle"-->
                  <!--icon="sort-descending"-->
                  <!--@click="arrowUpTop"-->
          <!--&gt;</a-button>-->
        <!--</a-tooltip>-->

        <!--<a-tooltip placement="topLeft">-->
          <!--<template slot="title">-->
            <!--<span>Bottom</span>-->
          <!--</template>-->
          <!--<a-button-->
                  <!--size="small"-->
                  <!--type="primary"-->
                  <!--shape="circle"-->
                  <!--icon="sort-ascending"-->
                  <!--@click="arrowUpBottom"-->
          <!--&gt;</a-button>-->
        <!--</a-tooltip>-->




        <a-tooltip placement="topLeft">
          <template slot="title">
            <span>{{ $t("publicLang.Save") }}</span>
          </template>
          <img @click="sortPagepro" class="sbxs" src="../../../assets/img/ss-save.png"  width="22" height="22">
        </a-tooltip>
      </a-col>

      <a-col class="ml4">
        <a-row type="flex" justify="start">
          <a-col><span>{{ $t("generic.PagePropertyGroupName") }}</span></a-col>
          <a-col style="margin: 0 4px;">
            <a-tooltip
              :trigger="['focus']"
              placement="topLeft"
              overlayClassName="numeric-input"
            >
              <span slot="title" v-if="pagePropertyGroupName.length > 0">
                {{ pagePropertyGroupName }}
              </span>
              <template slot="title" v-else>
                {{ $t("generic.PagePropertyGroupName") }}
              </template>
              <a-input
                size="small"
                placeholder="Basic usage"
                v-model="pagePropertyGroupName"
              />
            </a-tooltip>
          </a-col>
          <a-col>
            <a-input-number :min="1" :max="100" v-model="groupNameSort" size="small" style="margin-right: 4px;"/>
          </a-col>
          <a-col>
            <a-button size="small" type="primary" @click="PropertyGroupNameAdd"> {{ $t("generic.Apply") }}</a-button>
          </a-col>
        </a-row>
      </a-col>
    </a-row>
    <a-table
      :rowSelection="{
        selectedRowKeys: selectedRowKeys,
        onChange: onSelectChange
      }"
      :dataSource="pagePropertylist"
      :columns="columns"
      :pagination="Nopagination"
      size="small"
      :loading="loading"
      :locale="tabelText"
    >
      <template
        v-for="(item, index) in scopedSlotsArray"
        :slot="item"
        slot-scope="text"
      >
        <span :key="index">
          <a-tooltip placement="topLeft">
            <template slot="title">
              <span class="tableFontSize">{{
                text === "1" || text === true
                  ? "Yes"
                  : text === "0" || text === false
                  ? "NO"
                  : text === null
                  ? "-"
                  : text
              }}</span>
            </template>
            <div class="tableFontSize" v-if="item != 'FieldPattern'">
              {{
                text === "1" || text === true
                  ? "Yes"
                  : text === "0" || text === false
                  ? "No"
                  : text === null
                  ? "-"
                  : text
              }}
            </div>
            <a-icon type="tags" v-else />
          </a-tooltip>
        </span>
      </template>
      <img slot="operation" slot-scope="text" @click="EditpagePro(text)" class="sbxs" src="../../../assets/img/ss-edit.png"  width="22" height="22">
      <img slot="editMulti" slot-scope="text" @click="EditMultiLanguage(text)" class="sbxs" src="../../../assets/img/ss-edit.png"  width="22" height="22">
    </a-table>

    <a-modal
      title="Edit PageProperty"
      v-model="visible"
      width="50%"
      :maskClosable="maskClosable"
    >
      <template slot="footer">
        <a-button type="primary" @click="submitPagePro" size="small">{{ $t('publicLang.Save') }}</a-button>
      </template>
      <a-form :form="form">
        <a-row :gutter="24">
          <a-col :span="12">
            <a-form-item :label="$t('generic.FieldName')" v-bind="formItemLayout">
              <a-input
                :placeholder="$t('generic.FieldName')"
                autocomplete="off"
                size="small"
                style="width: 100%"
                disabled
                v-decorator="[
                  'fieldName',
                  { initialValue: editTargetPagePro.FieldName }
                ]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('generic.defaultValue')" v-bind="formItemLayout">
              <a-input
                :placeholder="$t('generic.defaultValue')"
                size="small"
                autocomplete="off"
                style="width: 100%"
                v-decorator="[
                  'defaultVal',
                  { initialValue: editTargetPagePro.DefaultValue }
                ]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('generic.Mandatory')" v-bind="formItemLayout">
              <a-switch
                size="small"
                v-decorator="[
                  'mandatory',
                  {
                    valuePropName: 'checked',
                    initialValue:
                      editTargetPagePro.Mandatory === '1' ? true : false
                  }
                ]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="6" style="padding-right: 0px">
            <a-form-item :label="$t('generic.Disaplyable')" v-bind="formItemLayout2">
              <a-switch
                size="small"
                v-decorator="[
                  'displayable',
                  {
                    valuePropName: 'checked',
                    initialValue:
                      editTargetPagePro.Disaplyable === '1' ? true : false
                  }
                ]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="3" style="padding-right: 0px">
            <a-form-item :label="$t('generic.Like')" v-bind="formItemLayout2">
              <a-switch
                  size="small"
                  @change="likeChange"
                  v-decorator="[
                  'isSupportLike',
                  {
                    valuePropName: 'checked',
                    initialValue:
                      editTargetPagePro.isSupportLike === '1' ? true : false
                  }
                ]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item :label="$t('generic.isShowCopy')" v-bind="formItemLayout">

              <a-switch
                      size="small"
                      v-decorator="[
                            'isShowCopy',
                            {
                              valuePropName: 'checked',
                              initialValue: editTargetPagePro.isShowCopy
                            }
                          ]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('generic.Searchable')" v-bind="formItemLayout">
              <a-switch
                size="small"
                v-decorator="[
                  'searchable',
                  {
                    valuePropName: 'checked',
                    initialValue:
                      editTargetPagePro.Searchable === '1' ? true : false
                  }
                ]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('generic.Editable')" v-bind="formItemLayout">
              <a-switch
                size="small"
                v-decorator="[
                  'editable',
                  {
                    valuePropName: 'checked',
                    initialValue:
                      editTargetPagePro.Editable === '1' ? true : false
                  }
                ]"
              />
            </a-form-item>
          </a-col>


          <a-col :span="12">
            <a-form-item :label="$t('generic.IsShowTitle')" v-bind="formItemLayout">
              <a-switch
                 size="small"
                 v-decorator="[
                  'isShowTitle',
                  {
                    valuePropName: 'checked',
                    initialValue: editTargetPagePro.isShowTitle
                  }
                ]"
              />
            </a-form-item>
          </a-col>

          <a-col :span="12">
            <a-form-item :label="$t('generic.ShowTitleSeq')" v-bind="formItemLayout">
              <a-input-number :min="1"
                  size="small"
                 v-decorator="[
                  'showTitleSeq',
                  { initialValue: editTargetPagePro.showTitleSeq }
                ]" />
            </a-form-item>
          </a-col>




          <a-col :span="12" v-if="editTargetPagePro.displayOption">
            <a-form-item :label="$t('generic.OptionType')" v-bind="formItemLayout">
              <a-select
                style="width: 100%"
                size="small"
                showSearch
                :placeholder="$t('publicLang.PleaseSelect')"
                allowClear
                v-decorator="[
                  'isOption',
                  {
                    initialValue:
                      editTargetPagePro.isOption === null
                        ? undefined
                        : editTargetPagePro.isOption
                  }
                ]"
              >
                <a-select-option
                  v-for="(item, index) in isOptionArr"
                  :key="index"
                  :value="item.key"
                >
                  {{ item.value }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('generic.ExtentionValue')" v-bind="formItemLayout">
              <a-select
                showSearch
                style="width: 100%"
                size="small"
                :placeholder="$t('publicLang.PleaseSelect')"
                allowClear
                v-decorator="[
                  'extentionValueType',
                  {
                    initialValue:
                      editTargetPagePro.extentionValueType == null
                        ? undefined
                        : editTargetPagePro.extentionValueType
                  }
                ]"
              >
                <a-select-option
                  v-for="(item, index) in extentionValueType"
                  :key="index"
                  :value="item.key"
                >
                  {{ item.value }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :span="12">
            <a-form-item :label="$t('generic.GenIdtype')" v-bind="formItemLayout">
              <a-input
                size="small"
                :placeholder="$t('generic.GenIdtype')"
                v-decorator="[
                  'genIdType',
                  {
                    initialValue:
                      editTargetPagePro.genIdType == null
                        ? undefined
                        : editTargetPagePro.genIdType
                  }
                ]"
              />
            </a-form-item>
          </a-col>

          <a-col :span="12">
            <a-form-item :label="$t('generic.FieldType')" v-bind="formItemLayout">
              <a-select
                :placeholder="$t('publicLang.PleaseSelect')"
                style="width: 100%"
                size="small"
                showSearch
                allowClear
                v-decorator="[
                  'fieldType',
                  {
                    initialValue:
                      editTargetPagePro.fieldType == null
                        ? undefined
                        : editTargetPagePro.fieldType
                  }
                ]"
              >
                <a-select-option key="DROP">Dropdown</a-select-option>
                <a-select-option key="LOOKUP">Lookup</a-select-option>
                <a-select-option key="POPUP">Popup</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('generic.Isitunique')" v-bind="formItemLayout">
              <a-switch
                size="small"
                v-decorator="[
                  'uniquable',
                  {
                    valuePropName: 'checked',
                    initialValue:
                      editTargetPagePro.uniquable === '1' ? true : false
                  }
                ]"
              />
            </a-form-item>
          </a-col>

          <a-col :span="12">
            <a-form-item :label="$t('generic.Width')" v-bind="formItemLayout">
              <a-input-number
                style="width: 100%;"
                size="small"
                :placeholder="$t('generic.Width')"
                :min="1"
                v-decorator="[
                  'proWidth',
                  {
                    initialValue: editTargetPagePro.proWidth
                  }
                ]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('generic.Statistics')" v-bind="formItemLayout">
              <a-select
                allowClear
                showSearch
                style="width: 100%"
                size="small"
                :placeholder="$t('publicLang.PleaseSelect')"
                v-decorator="[
                  'statistics',
                  {
                    initialValue: editTargetPagePro.statistics
                  }
                ]">
                <a-select-option value="SUM">SUM</a-select-option>
                <a-select-option value="Count">Count</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>



          <a-col :span="12">
            <a-form-item :label="$t('generic.Hyperlink')" v-bind="formItemLayout">
              <a-input
                      size="small"
                      :placeholder="$t('generic.Hyperlink')"
                      v-decorator="[
                  'hyperlink',
                  {
                    initialValue:
                      editTargetPagePro.hyperlink == null
                        ? undefined
                        : editTargetPagePro.hyperlink
                  }
                ]"
              />
            </a-form-item>
          </a-col>


          <a-col :span="24">
            <a-divider  style="margin: 10px 0"/>
          </a-col>

          <a-col :span="12">
            <a-form-item :label="$t('generic.Module')" v-bind="formItemLayout">
              <a-cascader
                allowClear
                size="small"
                :fieldNames="{
                  label: 'moduleCode',
                  value: 'key',
                  children: 'children'
                }"
                :options="pageProModules"
                expandTrigger="hover"
                :placeholder="$t('publicLang.PleaseSelect')"
                v-model="pageproModuleModel"
              />
            </a-form-item>
          </a-col>

          <a-col :span="12">
            <a-form-item :label="$t('generic.MapToModule')" v-bind="formItemLayout">
              <a-cascader
                allowClear
                size="small"
                :fieldNames="{
                  label: 'moduleCode',
                  value: 'key',
                  children: 'children'
                }"
                :options="pageproMaoToModules"
                expandTrigger="hover"
                :placeholder="$t('publicLang.PleaseSelect')"
                v-model="pageproMaoToModel"
              />
            </a-form-item>
          </a-col>

          <a-col :span="12">
            <a-form-item :label="$t('generic.FieldMap')" v-bind="formItemLayout">
              <a-select
                allowClear
                showSearch
                size="small"
                :placeholder="$t('publicLang.PleaseSelect')"
                @dropdownVisibleChange="($event) =>{$event ? dropdownVisibleChange() : null }"
                v-decorator="[
                  'mapUid',
                  {
                    initialValue: editTargetPagePro.mapUid
                  }
                ]"
              >
                <a-select-option
                  v-for="(item, index) in FormFieldMapList"
                  :key="index"
                  :value="item.fieldMapUid"
                  >{{ item.mapName }}</a-select-option
                >
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :span="12">
            <a-form-item :label="$t('generic.DataFormat')" v-bind="formItemLayout">
              <a-input
                  :placeholder="$t('generic.DataFormat')"
                  size="small"
                  v-decorator="[
                  'dataFormat',
                  {
                    initialValue:
                      editTargetPagePro.dataFormat == null
                        ? undefined
                        : editTargetPagePro.dataFormat
                  }
                ]"
              />
            </a-form-item>
          </a-col>

        </a-row>
        <a-row :gutter="24">
          <a-col :span="24">
            <a-form-item :label="$t('generic.FieldPattern')" :labelCol="{ span: 4 }">
              <div style="display: flex;align-items: center">
                <a-textarea
                  :placeholder="$t('generic.FieldPattern')"
                  size="small"
                  :rows="3"
                  style="width:70%"
                  disabled
                  :value="JSON.stringify(pageProPatterJson)"
                />
                <img  @click="editFieldPatterJson" class="sbxs mllr4" src="../../../assets/img/ss-add.png"  width="22" height="22">
                <img  @click="clearFieldPatter" class="sbxs" src="../../../assets/img/ss-delete.png"  width="22" height="22">
              </div>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </a-modal>

    <a-modal
      :title="$t('generic.FieldPattern')"
      v-model="configPatterVis"
      width="60%"
      :maskClosable="maskClosable"
      @cancel="cancelFiledPattern"
    >
      <template slot="footer">
        <a-button type="primary" @click="getFiledPatterJson">{{ $t('publicLang.Save') }}</a-button>
      </template>
      <a-form :form="pageProPatternForm">
        <a-row :gutter="24">
          <a-col :span="12">
            <a-form-item :label="$t('generic.Module')" v-bind="formItemLayout">
              <a-cascader
                :fieldNames="{
                  label: 'moduleCode',
                  value: 'key',
                  children: 'children'
                }"
                size="small"
                :options="gmcuidModule"
                expandTrigger="hover"
                :placeholder="$t('publicLang.PleaseSelect')"
                v-model="ConfigGmcModule"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('generic.Function')" v-bind="formItemLayout">
              <a-select
                style="width: 100%"
                allowClear
                showSearch
                size="small"
                :placeholder="$t('publicLang.PleaseSelect')"
                v-model="ConfigGmcFunction"
              >
                <a-select-option
                  v-for="(item, index) in gmcuidfunction"
                  :value="item.functionKey"
                  :key="index"
                  >{{ item.functionValue }}</a-select-option
                >
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('generic.GenericName')" v-bind="formItemLayout">
              <a-select
               showSearch
                optionFilterProp="children"
                :filterOption="filterOption"
                allowClear
                style="width: 100%"
                size="small"
                :placeholder="$t('publicLang.PleaseSelect')"
                @dropdownVisibleChange="($event) =>{$event ? dropdownVisibleChange() : null }"
                v-decorator="[
                  'gmcUid',
                  { initialValue: pageProPatterJson.gmcUid }
                ]"
              >
                <a-select-option
                  v-for="(item, index) in gmcuidGeneric"
                  :value="item.uid"
                  :key="index"
                  >{{ item.name }}</a-select-option
                >
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :span="12">
            <a-form-item :label="$t('generic.GenericParameters')" v-bind="formItemLayout">
              <a-select
                allowClear
                size="small"
                :placeholder="$t('publicLang.PleaseSelect')"
                v-decorator="[
                  'params',
                  {
                    initialValue:
                      pageProPatterJson.params == null
                        ? []
                        : pageProPatterJson.params,
                    rules: [{ type: 'array' }]
                  }
                ]"
                mode="multiple"
              >
                <a-select-option
                  v-for="(item, index) in ParametersList"
                  :value="item.detailUid"
                  :key="index"
                  >{{ item.FieldName }}</a-select-option
                >
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('generic.DefaultSelected')" v-bind="formItemLayout">
              <a-switch
                   size="small"
                   v-decorator="[
                  'defaultSelected',
                  {
                      initialValue: pageProPatterJson.defaultSelected,
                      valuePropName: 'checked'
                  }
                ]"/>
            </a-form-item>
          </a-col>

          <a-col :span="12">
            <a-form-item :label="$t('generic.IsReserveAdmin')" v-bind="formItemLayout">
              <a-switch
                   size="small"
                  v-decorator="[
                    'reserveAdmin',
                    {
                        initialValue: pageProPatterJson.reserveAdmin,
                        valuePropName: 'checked'
                    }
                ]"/>
            </a-form-item>
          </a-col>

          <a-col :span="12">
            <a-form-item :label="$t('generic.TitleInfo')" v-bind="formItemLayout">
              <a-textarea size="small" :placeholder="$t('generic.TitleInfo')" :rows="2"
                   v-decorator="[
                    'titleInfo',
                    {
                        initialValue: pageProPatterJson.titleInfo,
                    }
                ]"
              />
            </a-form-item>
          </a-col>



          <a-col :span="24">
            <a-divider  style="margin: 10px 0"/>
          </a-col>

          <a-col :span="12">
            <a-form-item :label="$t('generic.UniqueParameter')" v-bind="formItemLayout">
              <a-select
                allowClear
                size="small"
                mode="multiple"
                :placeholder="$t('publicLang.PleaseSelect')"
                v-decorator="[
                  'uniqueParams',
                  {
                    initialValue:
                      pageProPatterJson.uniqueParams == null
                        ? []
                        : pageProPatterJson.uniqueParams,
                    rules: [{ type: 'array' }]
                  }
                ]"
              >
                <a-select-option
                  v-for="(item, index) in ParametersList"
                  :value="item.detailUid"
                  :key="index"
                  >{{ item.FieldName }}</a-select-option
                >
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('generic.Depend')" v-bind="formItemLayout">
              <a-select
                style="width: 100%"
                allowClear
                size="small"
                :placeholder="$t('publicLang.PleaseSelect')"
                v-decorator="[
                  'dependOn',
                  {
                    initialValue: parseInt(pageProPatterJson.dependOn)
                  }
                ]"
              >
                <a-select-option
                  v-for="(item, index) in ParametersList"
                  :value="item.detailUid"
                  :key="index"
                  >{{ item.FieldName }}</a-select-option
                >
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :span="12">
            <a-form-item :label="$t('generic.Condition')" v-bind="formItemLayout">
              <a-select
                style="width: 100%"
                allowClear
                size="small"
                :placeholder="$t('publicLang.PleaseSelect')"
                v-decorator="[
                  'condition',
                  {
                    initialValue: pageProPatterJson.condition
                  }
                ]"
              >
                <a-select-option value="<"> < </a-select-option>
                <a-select-option value="="> = </a-select-option>
                <a-select-option value=">"> > </a-select-option>
                <a-select-option value="<>"> <> </a-select-option>
                <a-select-option value=">="> >= </a-select-option>
                <a-select-option value="<="> <= </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :span="12">
            <a-form-item :label="$t('generic.IsDefType')" v-bind="formItemLayout">
              <a-select
                  style="width: 100%"
                  size="small"
                  allowClear
                  :placeholder="$t('publicLang.PleaseSelect')"
                  v-decorator="[
                  'isDefType',
                  {
                    initialValue: pageProPatterJson.isDefType
                  }
                ]"
              >
                <a-select-option value="Date"> Date </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

        </a-row>
      </a-form>
      <a-row :gutter="24">
        <a-col :span="24">
          <a-divider  style="margin: 10px 0">{{ $t('generic.ConfigurationMethod') }}</a-divider>
        </a-col>
        <a-col :span="12">
          <a-form-item :label="$t('generic.CalcParameters')" v-bind="formItemLayout">
            <a-select
                    allowClear
                    size="small"
                    mode="multiple"
                    style="width: 100%"
                    :placeholder="$t('publicLang.PleaseSelect')"
                    v-model="computeJson.computeMultiple"
            >
              <a-select-option
                      v-for="(item, index) in ParametersList"
                      :value="item.detailUid"
                      :key="index"
              >{{ item.FieldName }}</a-select-option
              >
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item :label="$t('generic.CalcType')" v-bind="formItemLayout">
            <a-select
                style="width: 100%"
                size="small"
                v-model="computeJson.computeTypeTop"
                :placeholder="$t('publicLang.PleaseSelect')"
                allowClear>
              <a-select-option value="+">+</a-select-option>
              <a-select-option value="*">*</a-select-option>
              <a-select-option value="/">/</a-select-option>
              <a-select-option value="DAY_OF_WEEK">DAY_OF_WEEK</a-select-option>
              <a-select-option value="DAY_OF_WEEK_BY_ZIMM_FLIGHT_GP">DAY_OF_WEEK_BY_ZIMM_FLIGHT_GP</a-select-option>
              <a-select-option value="ISO_YEAR_WEEK">ISO_YEAR_WEEK</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item :label="$t('generic.SurfixParameter')" v-bind="formItemLayout">
            <a-input-number
                    style="width: 100%"
                    size="small"
                    v-model="computeJson.computeTypeNum"
                    :placeholder="$t('generic.SurfixParameter')"/>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item :label="$t('generic.CalcType')" v-bind="formItemLayout">
            <a-select
                    style="width: 100%"
                    size="small"
                    v-model="computeJson.computeTypeBtm"
                    :placeholder="$t('publicLang.PleaseSelect')"
                    allowClear>
              <a-select-option value="+">+</a-select-option>
              <a-select-option value="*">*</a-select-option>
              <a-select-option value="/">/</a-select-option>
              <a-select-option value="DAY_OF_WEEK">DAY_OF_WEEK</a-select-option>
              <a-select-option value="DAY_OF_WEEK_BY_ZIMM_FLIGHT_GP">DAY_OF_WEEK_BY_ZIMM_FLIGHT_GP</a-select-option>
              <a-select-option value="ISO_YEAR_WEEK">ISO_YEAR_WEEK</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="24">
          <a-divider  style="margin: 10px 0">{{ $t('generic.ComputationalEvent') }}</a-divider>
        </a-col>
        <a-col :span="12">
          <a-form-item :label="$t('generic.TriggerFields')" v-bind="formItemLayout">
            <a-select
              allowClear
              mode="multiple"
              style="width: 100%"
              size="small"
              :placeholder="$t('publicLang.PleaseSelect')"
              v-model="computeJson.transmitParams">
              <a-select-option
                      v-for="(item, index) in ParametersList"
                      :value="item.detailUid"
                      :key="index"
              >{{ item.FieldName }}</a-select-option
              >
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item :label="$t('generic.IsTrigger')" v-bind="formItemLayout">
            <a-switch v-model="computeJson.configChange"  size="small" @change="computeJsonIsChange"/>
          </a-form-item>
        </a-col>
      </a-row>
    </a-modal>

    <!--editMulti-->
    <a-modal
            :title="$t('userlang.Language')"
            v-model="multiLanguageDialogVisable"
            width="60%"
            :maskClosable="false"
            @cancel="cancelFiledPattern"
    >
      <template slot="footer">
        <a-button size="small" type="primary" @click="saveMultiLang">{{ $t('publicLang.Save') }}</a-button>
      </template>
      <a-form :form="form" >
        <a-form-item :label="$t('userlang.englishName')"  v-bind="formItemLayout">
          <a-input size="small" style="width: 80%" v-model="englishName"/>
        </a-form-item>
        <a-form-item :label="$t('userlang.sumplifiedName')"  v-bind="formItemLayout">
          <a-input size="small" style="width: 80%" v-model="simplCnName"/>
        </a-form-item>
        <a-form-item :label="$t('userlang.traditionalName')"  v-bind="formItemLayout" >
          <a-input size="small" style="width: 80%" v-model="tradiCnName"/>
        </a-form-item>
        <a-form-item :label="$t('userlang.koreanName')"  v-bind="formItemLayout" >
          <a-input size="small" style="width: 80%" v-model="korName"/>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>
<script>
import { mapState } from "vuex";
import ajax from "../../../api/ajax";
import api from "../../../api/url";
export default {
  props: {
    pagedbSelectList: {
      type: Array,
      default: function() {
        return [];
      }
    }
  },
  data() {
    return {
      computeJson:{
          computeMultiple: undefined,
          computeTypeTop: undefined,
          computeTypeNum: '',
          computeTypeBtm: undefined,
          configChange: false,
          transmitParams: undefined
      },
      groupNameSort: null,
      pagePropertyGroupName: "",
      form: this.$form.createForm(this),
      pageProPatternForm: this.$form.createForm(this),
      maskClosable: false, // 取消点击遮罩取消
      tabelText: {
        emptyText: "No record found"
      }, // table 编辑内容
      isOptionArr: [
        { key: "0", value: "key" },
        { key: "1", value: "value" },
        { key: "2", value: "empty" }
      ], // Option Type data
      scopedSlotsArray: [
        "FieldName",
        "Mandatory",
        "Disaplyable",
        "isSupportLike",
        "Searchable",
        "Editable",
        "DefaultValue",
        "FieldPattern",
        "sectionName"
      ], // table slot
      formItemLayout: {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 8 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 }
        }
      },
      formItemLayout2: {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 16 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 8 }
        }
      },

      visible: false, // 弹窗add edit flag
      Nopagination: false, // 取消分页
      selectedRowKeys: [], // table check选下标
      checkrows: [], // table 选中的list
      pagePropertylist: [], // table data
      loading: false, // table loading
      editTargetPagePro: {}, // 编辑当条数据
      extentionValueType: [],
      pageProPatterJson: {}, // 配置pageproJson
      multiLanguageDialogVisable: false,
      configPatterVis: false,
      gmcuidModule: [], // Filed Pattern module 下拉数据
      ConfigGmcModule: [], // Filed Pattern module 选中的items
      ConfigGmcFunction: undefined, // Filed Pattern Function 下拉数据
      gmcuidfunction: [], // Filed Pattern Function 下拉选中的值
      gmcuidGeneric: [], // Generic Name 下拉数据
      ParametersList: [], // Filed Pattern Parameters 下拉数据
      pageProModules: [],
      pageproModuleModel: [],
      pageproMaoToModules: [],
      pageproMaoToModel: [],
      FormFieldMapList: [],
      simplCnName:'',
      tradiCnName:'',
      englishName:'',
      korName:'',
      schemaUid:'',

    };
  },
  computed: {
      columns(){
        return [
            {
                title: this.$t('generic.FieldName'),
                dataIndex: "FieldName",
                width: 100,
                scopedSlots: { customRender: "FieldName" }
            },
            {
                width: 100,
                title: this.$t('generic.Disaplyable'),
                dataIndex: "Disaplyable",
                scopedSlots: { customRender: "Disaplyable" }
            },
            {
              width: 100,
              title: this.$t('generic.Like'),
              dataIndex: "isSupportLike",
              scopedSlots: { customRender: "isSupportLike" }
            },
            {
                width: 100,
                title: this.$t('generic.Editable'),
                scopedSlots: { customRender: "Editable" },
                dataIndex: "Editable"
            },
            {
                width: 100,
                title: this.$t('generic.Searchable'),
                scopedSlots: { customRender: "Searchable" },
                dataIndex: "Searchable"
            },
            {
                title: this.$t('generic.Mandatory'),
                dataIndex: "Mandatory",
                scopedSlots: { customRender: "Mandatory" },
                width: 100
            },
            {
                width: 100,
                title: this.$t('generic.DefaultValue'),
                scopedSlots: { customRender: "DefaultValue" },
                dataIndex: "DefaultValue"
            },
            {
                width: 100,
                title: this.$t('generic.FieldPattern'),
                scopedSlots: { customRender: "FieldPattern" },
                dataIndex: "FieldPattern"
            },
            {
                width: 100,
                title:  this.$t('generic.Group'),
                scopedSlots: { customRender: "sectionName" },
                dataIndex: "sectionName"
            },
            {
                width: 100,
                title: this.$t('generic.Action'),
                scopedSlots: { customRender: "operation" }
            }
        ]
      },
    ...mapState(["uid"]) // 获取uid
  },
  watch: {
    uid(val) {
      if (val != "") {
        this.iniFreshTable();
      }
    }
  },
  created() {
    this.iniFreshTable();
  },
  methods: {
          filterOption(input, option) {
          return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      },
      computeJsonIsChange(val){
          this.computeJson.configChange = val
      },
    PropertyGroupNameAdd() {
      if (this.checkrows.length > 0) {
        let paramsArray = [];
        for (let ii in this.checkrows) {
          paramsArray.push(this.checkrows[ii].detailUid);
        }
        let params = {
          name: this.pagePropertyGroupName,
          uids: paramsArray,
          seq: this.groupNameSort
        };
        ajax.post(api.SECTIONNAME, params).then(res => {
          if (res.code == 200) {
            this.iniFreshTable();
          }
        });
      } else {
        this.$customMessage.warning(this.$t('publicLang.pleaseOneOnly'));
      }
    },
    dropdownVisibleChange() {
      let params = {
        fromModuleCode: this.pageproModuleModel[1],
        toModuleCode: this.pageproMaoToModel[1]
      };
      ajax.get(api.DROPFIELMAP, params).then(res => {
        this.FormFieldMapList = res.data;
      });
    },
    //      确定排序
    sortPagepro() {
      this.loading = true;
      let propertySortVo = this.pagePropertylist;
      ajax.post(api.SORTPROPRTTYDETAIL, propertySortVo).then(res => {
        if (res.code === 200) {
          this.iniFreshTable();
          this.selectedRowKeys = [];
        }
      });
    },
////      最后
//      arrowUpBottom(){
//          if (this.selectedRowKeys.length != 1) {
//              this.$customMessage.warning(this.$t('publicLang.pleaseOneOnly'));
//          }else {
//              let ab = this.pagePropertylist;
//              for (let i in ab) {
//                  if (ab[i] == this.checkrows[0]) {
//                      ab.splice(i, 1);
//                      this.pagePropertylist.push(this.checkrows[0])
//                      ab[ab.length - 1].seq = ab[ab.length - 2].seq
//                      break
//                  }
//              }
//              for (let i in ab) {
//                  if(ab.length - 1 != i){
//                      ab[i].seq = ab[i].seq -1
//                  }
//              }
//          }
//      },
////      置顶
//      arrowUpTop(){
//          if (this.selectedRowKeys.length != 1) {
//              this.$customMessage.warning(this.$t('publicLang.pleaseOneOnly'));
//          }else{
//              let ab = this.pagePropertylist;
//              for(let i in ab){
//                  if(ab[i] == this.checkrows[0]){
//                      ab.splice(i,1);
//                      this.pagePropertylist.unshift(this.checkrows[0])
//                      ab[0].seq = ab[1].seq
//                      break
//                  }
//              }
//              for(let i in ab){
//                  if(i > 0){
//                      ab[i].seq = ab[i].seq + 1
//                  }
//              }
//          }
//      },
    //      往上排序
    arrowUpEvent() {
      if (this.selectedRowKeys.length != 1) {
        this.$customMessage.warning(this.$t('publicLang.pleaseOneOnly'));
      } else {
        let index = this.getIndexOfSel(this.selectedRowKeys[0]);
        if (index == 0) {
          return false;
        }
        let ab = this.pagePropertylist;
        let temp = ab[index - 1];

        let SeqTemp1 = ab[index].seq;
        let seqTemp2 = ab[index - 1].seq;
        ab[index - 1].seq = SeqTemp1;
        ab[index].seq = seqTemp2;

        ab[index - 1] = ab[index];
        ab[index] = temp;
        this.pagePropertylist = ab;
        this.$forceUpdate();
      }
    },
    //      往下排序
    arrowDown() {
      let index = this.getIndexOfSel(this.selectedRowKeys[0]);
      let ii = parseInt(index) + 1;
      if (ii > this.pagePropertylist.length - 1) {
        return false;
      }
      let ab = this.pagePropertylist;
      let SeqTemp1 = ab[ii].seq;
      let seqTemp2 = ab[index].seq;
      ab[ii].seq = seqTemp2;
      ab[index].seq = SeqTemp1;

      let temp = ab[ii];
      ab[ii] = ab[index];
      ab[index] = temp;

      this.pagePropertylist = ab;
      this.$forceUpdate();
    },

    //      过滤网上网下
    getIndexOfSel(val) {
      for (let ii in this.pagePropertylist) {
        if (this.pagePropertylist[ii].key === val) {
          return ii;
        }
      }
    },
    //      删除PageProperty列表数据
    deletePageProperty() {
      this.loading = true;
      if (this.checkrows.length > 0) {
        let params = {};
        let deleteArray = [];
        for (let i in this.checkrows) {
          deleteArray.push(this.checkrows[i].detailUid);
        }
        params.propertyUid = deleteArray;
        ajax.post(api.DELETEPROPERTYDETAIL, params).then(res => {
          if (res.code === 200) {
            this.iniFreshTable("delete");
          }
        });
      } else {
        this.$customMessage.warning(this.$t('publicLang.PleaseSltAtleast'));
      }
    },
    //     获取dbschema中schemaUids提交
    iniFreshTable(type) {
      this.loading = true;
      let pagedbSelectList = this.pagedbSelectList;
      let schemaUids = [];
      if (type === "resh") {
        for (let i in pagedbSelectList) {
          schemaUids.push(pagedbSelectList[i].schemaUid);
        }
      }
      if (type === "delete") {
        schemaUids = [];
      }

      let schemaParas = {
        schemaUids: schemaUids,
        uid: this.uid
      };
      if (this.uid === "") {
        this.loading = false;
        return;
      }
      ajax.post(api.REFRESHPROPERTYDETAIL, schemaParas).then(res => {
        this.loading = false;
        this.pagePropertylist = res.data;
        this.selectedRowKeys = [];
      });
    },
    //      table 所选中
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.checkrows = selectedRows;
    },
    //      编辑表格list数据
    EditpagePro(text) {
      ajax.get(api.GETMODULEDROPDATA).then(res => {
        this.pageProModules = res.data;
        this.pageproMaoToModules = res.data;
      });
      this.pageproModuleModel = [];
      this.pageproMaoToModel = [];
      this.dropdownVisibleChange();
      ajax.get(api.EXTENTIONVALUETYPE).then(res => {
        this.extentionValueType = res.data;
      });
      this.editTargetPagePro = text;
      this.pageProPatterJson = this.editTargetPagePro.FieldPattern == null ? {} : this.editTargetPagePro.FieldPattern;
      this.computeJson = this.pageProPatterJson.computeJson != undefined ? this.pageProPatterJson.computeJson: {}
      this.visible = true;
    },
    //            提交edit
    submitPagePro() {
      this.form.validateFields((err, val) => {
        let params = val;
        params.mandatory = params.mandatory ? "1" : "0";
        params.displayable = params.displayable ? "1" : "0";
        params.isSupportLike = params.isSupportLike ? "1" : "0";
        params.editable = params.editable ? "1" : "0";
        params.searchable = params.searchable ? "1" : "0";
        params.detailUid = this.editTargetPagePro.detailUid;
        params.genericUid = this.uid;
        params.schemaUid = this.editTargetPagePro.SchemaUid;
        params.uniquable = params.uniquable ? "1" : "0";
        params.fieldPattern = this.pageProPatterJson;
          ajax.post(api.SAVEPROPERTYDETAIL, params).then(res => {
          if (res.code === 200) {
            this.visible = false;
            this.iniFreshTable();
            this.editTargetPagePro = {};
            this.form.resetFields();
          }
        });
      });
    },
    //            获取Filed patter 下拉数据
    editFieldPatterJson() {
      this.ConfigGmcModule = [];
      this.ConfigGmcFunction = undefined;
      ajax.get(api.GETMODULEDROPDATA).then(res => {
        this.gmcuidModule = res.data;
      });
      ajax.get(api.GETFUNCTIONDROPDATA).then(res => {
        this.gmcuidfunction = res.data;
      });

      let schemaParas = {
        schemaUids: [],
        uid: this.uid
      };
      ajax.post(api.REFRESHPROPERTYDETAIL, schemaParas).then(res => {
        this.ParametersList = res.data;
      });
      this.genericNameVisibleChange();
      this.configPatterVis = true;
    },
    //            获取genericName
    genericNameVisibleChange() {
      let params = {
        functionCode: this.ConfigGmcFunction,
        moduleCode: this.ConfigGmcModule[0],
        subModuleCode: this.ConfigGmcModule[1]
      };
      ajax.post(api.POSTFETCH, params).then(res => {
        this.gmcuidGeneric = res.data;
      });
    },
    //            取消配置json
    cancelFiledPattern() {
      this.pageProPatternForm.resetFields();
      this.gmcuidGeneric = [];
    },
    //          清楚配置
    clearFieldPatter() {
      this.pageProPatterJson = {};
    },
    //            Fieldpatter 提交
    getFiledPatterJson() {
        this.pageProPatternForm.validateFields((err, val) => {
        let getConfigJson = {};
        let gmcName = undefined;
        if (val.gmcUid != undefined) {
          for (let ii in this.gmcuidGeneric) {
            if (this.gmcuidGeneric[ii].uid == val.gmcUid) {
              gmcName = this.gmcuidGeneric[ii].name;
            }
          }
        }
        getConfigJson = val;
        getConfigJson.gmcName = gmcName;
        getConfigJson.computeJson = this.computeJson
        this.pageProPatterJson = getConfigJson;
        this.pageProPatternForm.resetFields();
        this.gmcuidGeneric = [];
        this.configPatterVis = false;
      });
    },
    EditMultiLanguage(text) {
      this.englishName = '';
      this.simplCnName = '';
      this.tradiCnName = '';
      this.korName = '';
      this.schemaUid = text.SchemaUid;
      let params = {//配置查询条件
        schemaUid: text.SchemaUid,
      }
      ajax.get(api.GETMULTILANGUAGEBYSCHEAMA,params).then(res => {
        this.multiLanguageDialogVisable = true;
        if (res.code == 200) {
          let resData = res.data;
          if(resData != undefined && resData != null) {
            this.englishName = resData.englishName;
            this.simplCnName = resData.simplCnName;
            this.tradiCnName = resData.tradiCnName;
            this.korName = resData.korName;
          }
        } else {
          this.$customMessage.warning(res.msg);
        }

      });
      this.multiLanguageDialogVisable = true;
    },
    saveMultiLang() {
      let params = {
        englishName: this.englishName,
        simplCnName: this.simplCnName,
        tradiCnName: this.tradiCnName,
        korName: this.korName,
        schemaUid: this.schemaUid
      };
      ajax.post(api.SAVEMULTILANGUAGEBYSCHEAMA, params).then(res => {
        if (res.code == 200) {
          this.$message.success(res.msg)
        } else {
          this.$customMessage.warning(res.msg);
        }
      });
    },
    likeChange(checked) {
      if(checked){
        const displayable = this.form.getFieldValue('displayable');
        if(!displayable){
          this.$customMessage.warning(this.$t('publicLang.PleaseCheckDisplayableFirst'));
          this.$nextTick(() => {
            this.form.setFieldsValue({
              isSupportLike: false
            });
          });
        }
      }
    },
  }
};
</script>
<style lang="less">
#pageProperty {
  margin-top: 10px;
  padding-bottom: 30px;
  .pageProperty-btn {
    margin-bottom: 10px;
    button {
      margin-right: 10px;
    }
  }
}
</style>
